import { GoogleAnalyticsService } from './../../google-analytics.service';
import { OneDrive } from 'app/dms/onedrive/onedrive.service';
import { OneDriveFoldersComponent } from './../../dms/one-drive-folders/one-drive-folders.component';
import { DataService } from './../../data.service';
import {
   Component, OnInit, Input, ElementRef, ViewChild, ViewContainerRef, OnDestroy
} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {TranslateService} from '@ngx-translate/core';
import {NewTaskComponent} from './new-task/new-task.component';
import {TaskFilterOption} from './task-filter-select/task-filter-select.component';
import {MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {AdvanceSearchDialogComponent} from '../advance-search-dialog/advance-search-dialog.component';
import {ViewFlowComponent} from '../view-flow/view-flow.component';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {RejectReasonComponent} from './reject-reason/reject-reason.component';
import {ReassignDialogComponent} from './reassign-dialog/reassign-dialog.component';
import {HistoryActivityDialogComponent} from '../history-activity-dialog/history-activity-dialog.component';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {MatSort} from '@angular/material/sort';
import {Toast} from 'app/shared/toast/toast';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {PaginatorComponent} from '../../shared/paginator/paginator.component';
import {Path} from 'app/shared/path';
import { ExportTaskDialogComponent } from '../export-task-dialog/export-task-dialog.component';
import { SocialLogin } from 'app/account/social-login';
import { SenderReassignDialogComponent } from './sender-reassign-dialog/sender-reassign-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import {DownloadMultipleTaskComponent} from "../../dms/download-multiple-task/download-multiple-task.component";
import {IncludeAuditTrailComponent} from "../sign-off/include-audit-trail/include-audit-trail.component";

declare let EnjoyHint: any;

@Component({
   selector: 'app-tasks',
   templateUrl: './tasks.component.html',
   styleUrls: ['./tasks.component.css'],
   animations: [
      trigger('tabChange', [
         state('hide', style({
            display: 'none',
            opacity: 0
         })),
         state('show', style({
            display: 'block',
            opacity: 1
         })),
         transition('hide => show', animate('150ms ease-in')),
         transition('show => hide', animate('150ms ease-out'))
      ])
   ]
})
export class TasksComponent implements OnInit, OnDestroy {
   errorMessage: any;
   title = '';
   @ViewChild('search', { static: true }) query: ElementRef;
   @ViewChild(AppLoaderComponent, { static: true }) loader: AppLoaderComponent;
   private path: string;
   private page = 0;
   private timer: any;
   @Input() trash = false;
   searchFocused: boolean;
   status: any;
   preventBlur: boolean;
   searchResult: any[];
   searchvalue: any;
   searching: any;
   doc_id: any;
   info: any;
   checkTitle = false;
   form: any;
   itemSearch: any;
   selectedTab: number;
   groupType= 'ng';
   filterType = '6m';
   yearOptions: Array<{display: number, value: string}> = [];
   /* Kept as stable array references (recomputed only in refreshFilterOptions, not read fresh
      on every template check) so binding them to [options] doesn't trip Angular's dev-mode
      ExpressionChangedAfterItHasBeenCheckedError, which a plain method call in that binding
      would since it'd return a new array identity on every change-detection pass. */
   dateRangeOptions: TaskFilterOption[] = [];
   groupByOptions: TaskFilterOption[] = [];
   items = [
      {name: 'flow 1', id: '43434'},
      {name: 'blue', id: 'Blue'}
   ];
   public item = {
      taskName: '',
      statusSearch: '',
      emailSender: '',
      emailSigner: '',
      sentDateFrom: '',
      sentDateTo: '',
      lastUpdateFrom: '',
      lastUpdateTo: ''
   };

   public firstIndex = {
      name: 'Files',
      tin: 'My Files'
   };
   btn_newTask: boolean;
   @ViewChild('description') descElement: ElementRef;
   @ViewChild('form1', {read: ViewContainerRef}) form1: ViewContainerRef;
   private newTask: MatDialogRef<NewTaskComponent>;

   @ViewChild('d0') d0: ElementRef;
   @ViewChild('selector') selector: ElementRef;

   // for task list
   states = ['expand', 'expand'];
   private viewRejReason: MatDialogRef<RejectReasonComponent>;
   private viewFlow: MatDialogRef<ViewFlowComponent>;

   hasMore: boolean;
   expandedSender: any[] = [];
   expandedSubSender: TaskList[] = [];
   isLoadingResults = false;
   isRateLimitReached = false;
   pageSize = 50;
   resultsLength = 0;

   clickActive: boolean;
   selectedRowIndex: number;
   displayedColumns = ['select', 'task_name', 'task_status', 'create_by', 'last_update_date', 'menu'];
   taskDataSource = new MatTableDataSource<TaskList | Group>([]);
   filterTaskValue: any;

   allData: any[] = [];
   _allGroup: any[] = [];
   groupByColumns: string[] = [];
   paramsTmp: any;
   activeItem: any;
   previewLoaded = false;
   sortOrder = 'last_update_date';
   sortDirect = 'desc';
   sortOrderTmp: string;
   sortDirectTmp: string;

   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild(MatSort) sort: MatSort;
   listFolder: any[] = [];
   searchFolder = '';
   nameSite: any;
   taskName: any;
   tin: any;
   checkCert: any;
   listChert: any[];
   selection = new SelectionModel<any>(true, []);
   maxSelectItems = 20;
   includeAuditTrialDialog : MatDialogRef<IncludeAuditTrailComponent>;

   private exportDialog: MatDialogRef<ExportTaskDialogComponent>;

   certList = [ /// certificate code ZE-1575
      {value: 'ZDOX', viewValue: 'choose-certificate.zdox_certificate'},
      {value: 'STCA', viewValue: 'choose-certificate.site_certificate'},
      {value: 'ISCA', viewValue: 'choose-certificate.individual_certificate'},
      {value: 'IDCA', viewValue: 'choose-certificate.individual_certificate_ca'}
   ];

   constructor(private route: ActivatedRoute,
               protected service: IdexService,
               private translate: TranslateService,
               private dialog: MatDialog,
               private toast: Toast,
               private router: Router,
               protected dataService: DataService,
               private onedrive: OneDrive,private socialLogin:SocialLogin,
               private googleAnalyticsService:GoogleAnalyticsService) {

      const taskSort = localStorage.getItem('taskSort');
      const taskSortDirect = localStorage.getItem('taskSortDirect');
      const taskPageIndex = localStorage.getItem('taskPageIndex');
      const taskPageSize = localStorage.getItem('taskPageSize');
      const groupType = localStorage.getItem('group_type');

      // Kept by DataService while the user stays inside the task area; a reload or a trip
      // outside it clears the service, so the list falls back to Last 6 Months.
      if (this.dataService.taskFilterType) {
         this.filterType = this.dataService.taskFilterType;
      }

      if (taskSort) {
         this.sortOrderTmp = taskSort;
         this.sortOrder = this.sortOrderTmp;
      }

      if (taskSortDirect) {
         this.sortDirectTmp = taskSortDirect;
         this.sortDirect = this.sortDirectTmp;
      }

      if (taskPageIndex) {
         this.page = parseInt(taskPageIndex, 10);
         localStorage.removeItem('taskPageIndex');
      } else {
         this.page = -1;
      }

      if (taskPageSize) {
         this.pageSize = parseInt(taskPageSize, 10);
         localStorage.removeItem('taskPageSize');
      } else {
         this.pageSize = 50;
      }
      if (groupType) {
         this.groupType = groupType
         if(this.groupType === 'sd'){
            this.groupByColumns = ['sender'];
         }else if(this.groupType === 'st'){
            this.groupByColumns = ['taskStatus'];
         }
      }
   }

   ngOnInit(): void {
      this.service.getProfile()
      .subscribe((data: any) => {
         this.checkCert = data.certDefault;
      });

      this.service.get('cert/list')
      .subscribe((data: any) => {
         if (data) {
               this.listChert = data;
         }
      }, error =>{
         this.toast.error(error.massage);
      });

      this.service.getTaskDownloadLimit()
      .subscribe((data: any) => {
         if (data && data.downloadLimit) {
            this.maxSelectItems = data.downloadLimit;
         }
      });

      this.clickActive = false;
      this.route.params.forEach((params: Params) => {
         this.paramsTmp = params;
         this.status = params['status'];

         this.taskDataSource = new MatTableDataSource<TaskList | Group>([]);
         if (this.page !== -1) {
            this.paginator.page = this.page;
         } else {
            this.paginator.page = 0;
         }
         this.translate.get('main').subscribe(msg => {
            switch (this.status) {
               case 'sign': this.title = msg.tasksAction; break;
               case 'sign_only': this.title = msg.tasksNS; break;
               case 'signed_doc': this.title = msg.tasksSignedDoc; break;
               case 'sent': this.title = msg.tasksSent; break;
               case 'draft': this.title = msg.tasksDraft; break;
               case 'deleted': this.title = msg.tasksDeleted; break;
               case 'wait_other': this.title = msg.taskWaitOther; break;
               case 'completed': this.title = msg.tasksCompleted; break;
               case 'reject': this.title = msg.tasksRejected; break;
               case 'search': case 'searchAdvanced': this.title = msg.search; break;
               case 'startFlow': this.title = msg.startFlow; break;
               case 'sender': this.title = msg.sender + ': ' + params['search']; break;
               default : this.title = msg.tasks; break;
            }
            this.refreshFilterOptions();
         });

         if (this.service.user.business && this.service.user.business.length !== 0) {
            this.listFolder = this.service.user.business;
            this.listFolder = [this.firstIndex].concat(this.listFolder);
         } else {
            this.listFolder = [];
         }
         this.selection.clear();
         this.getTaskList('load');
      });

      this.initializeYearOptions();
   }

   ngOnDestroy() {
      this.setSortPaging();
   }

   prevMonth(dateObj) {
      const tempDateObj = new Date(dateObj);

      if (tempDateObj.getMonth() > 0) {
         tempDateObj.setMonth(tempDateObj.getMonth() - 1);
      } else {
         tempDateObj.setFullYear(tempDateObj.getFullYear() - 1);
         tempDateObj.setMonth(11);
      }

      return tempDateObj;
   }

   getTaskList(type) {
      if (type === 'page' || type === 'filter' || type === 'searchAdvance') {
         this.selection.clear();
      }
      const {fromDate, toDate} = this.getFilterDateRange();
      this.dataService.getSenderList(fromDate + ' 00:00:00', toDate + ' 23:59:59');
      this.loader.show();
      this.taskDataSource = new MatTableDataSource<TaskList | Group>([]);
      this.isLoadingResults = true;

      const taskPageSize = localStorage.getItem('taskPageSize');
      if (taskPageSize) {
         this.pageSize = parseInt(taskPageSize, 10);
      } else if (this.paginator.size !== undefined) {
         this.pageSize = this.paginator.size;
      }

      if (this.filterTaskValue === undefined) {
         this.filterTaskValue = '';
      }

      let sort = 'last_update_date';
      let order = 'desc';

      if (this.sortOrderTmp) {
         sort = this.sortOrderTmp;
         this.sortOrderTmp = '';

         if (this.sortDirectTmp) {
            order = this.sortDirectTmp;
            this.sortDirectTmp = '';
         }
      } else if (this.sort) {
         sort = this.sort.active;
         order = this.sort.direction;
      }

      if (type === 'sort') {
         this.paginator.page = 0;
      } else if (this.page !== -1) {
         this.paginator.page = this.page;
         this.page = -1;
      }

      if (this.status === 'searchAdvanced') {
         const itemSearch = sessionStorage.getItem('itemSearch');
         if (itemSearch) {
            const filterSearch = JSON.parse(itemSearch);
            this.item.taskName = filterSearch.taskName;
            this.item.statusSearch = filterSearch.statusSearch;
            this.item.emailSender = filterSearch.emailSender;
            this.item.emailSigner = filterSearch.emailSigner;
            this.item.sentDateFrom = filterSearch.sentDateFrom;
            this.item.sentDateTo = filterSearch.sentDateTo;
            this.item.lastUpdateFrom = filterSearch.lastUpdateFrom;
            this.item.lastUpdateTo = filterSearch.lastUpdateTo;
         }
         this.searching = '';
         this.filterTaskValue = '';
         if (this.query) {
            this.query.nativeElement.value = '';
         }
         if(this.paginator.page > 0 && type === 'load'){ // reset when search
            this.paginator.page = 0;
         }

         this.service.listTaskSearchAdvanced(this.item, this.pageSize, this.paginator.page, sort, order).subscribe(data => {
               this.bindDataTable(JSON.parse(data));
               this.paginator.size = this.pageSize;
               this.loader.hide();
            },
            (error) => {
               this.errorMessage = error;
               this.loader.hide();
            });
      } else if (this.status === 'sender') {
         const senderName = this.paramsTmp['search'];

         this.searching = '';
         this.filterTaskValue = '';
         if (this.query) {
            this.query.nativeElement.value = '';
         }

         this.service.get('/task/taskSender?sender=' + senderName + '&fromDate=' + fromDate + ' 00:00:00' +
            '&toDate=' + toDate + ' 23:59:59' + '&sort=' + sort + '&order=' + order + '&pagesize=0&page=0')
            .subscribe((data) => {
               this.bindDataTable(data);
               this.paginator.size = data.totalCount;
               this.loader.hide();
               if (data != null) {
                  if (localStorage.getItem('first_task_open') !== 'true') {
                     this.onStartTutorial();
                     localStorage.setItem('first_task_open', 'true');
                  }
               } else {
                  this.router.navigate(['/tasks/all']);
                  /* TODO: change service if null return error */
               }
            }, error => {
               this.errorMessage = error;
               this.loader.hide();
         });
      } else {
         this.doc_id = '';
         if (this.status === 'search') {
            const kwSearch = this.paramsTmp['search'];
            if (kwSearch) {
               this.filterTaskValue = encodeURIComponent(kwSearch);
               this.searching = decodeURIComponent(kwSearch);
            }

            if (this.filterTaskValue === '#') {
               this.filterTaskValue = '/#';
            }
            if(this.paginator.page > 0 && type === 'load'){ // reset when search
               this.paginator.page = 0;
            }
         } else if (this.status === 'startFlow') {
            this.doc_id = this.paramsTmp['search'];
         } else {
            this.searching = '';
            this.filterTaskValue = '';
            if (this.query) {
               this.query.nativeElement.value = '';
            }
         }

         this.service.listTask(this.status, fromDate + ' 00:00:00', toDate + ' 23:59:59',
            this.pageSize, this.paginator.page, this.filterTaskValue, 0, this.doc_id, sort, order)
            .subscribe((data) => {
               this.bindDataTable(data);
               this.paginator.size = this.pageSize;
               this.loader.hide();

               if (data != null) {
                  if (localStorage.getItem('first_task_open') !== 'true') {
                     this.onStartTutorial();
                     localStorage.setItem('first_task_open', 'true');
                  }
               } else {
                  this.router.navigate(['/tasks/all']);
                  /* TODO: change service if null return error */
               }
            }, error => {
               this.errorMessage = error;
               this.loader.hide();
            });
      }
   }

   bindDataTable(data) {
      this.isLoadingResults = false;
      this.isRateLimitReached = false;
      this.selectedRowIndex = -1;
      this.resultsLength = data.totalCount;
      this.allData = data.items;
      let dataTasks;
      if(this.groupType === 'ng'){
         dataTasks = this.allData;
      }else {
         this.getGroupList(this.allData, 0, this.groupByColumns, null);
         dataTasks = this.addGroupsNew(this._allGroup, this.allData, this.groupByColumns, null);
      }
      this.taskDataSource = new MatTableDataSource(dataTasks);
      if (this.paginator.page !== data.pageIndex) {
         this.paginator.page = data.pageIndex;
      }
   }

   canNewTask() {
      if (this.status === 'all') {
         this.btn_newTask = true;
         return true;
      }
      this.btn_newTask = false;
      return false;
   }

   openNewTask() {
         this.router.navigate(['/create-task']);
   }

   onSearch(input: any, filterValue: any) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }

      const value = filterValue.trim();
      if (/[%|^{}[\]\\]/g.test(value)) {
         this.translate.get('alert.create_folder_errors').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches

         this.filterTaskValue = filterValue;

         input.blur();
         this.setSortPaging();

         sessionStorage.setItem('taskPath', 'tasks/search/' + this.filterTaskValue);
         this.router.navigate(['tasks/search/', this.filterTaskValue]);
      }

   }

   setSortPaging() {
      if (this.sort) {
         localStorage.setItem('taskSort', this.sort.active);
         localStorage.setItem('taskSortDirect', this.sort.direction);
      }
      if (this.paginator) {
         localStorage.setItem('taskPageIndex', this.paginator.page.toString());
         if (this.status !== 'sender') {
            localStorage.setItem('taskPageSize', this.paginator.size.toString());
         }
      }
   }

   onSearchChange(input: any) {
      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = encodeURIComponent(input.value.trim());
      if (q.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         const {fromDate, toDate} = this.getFilterDateRange();
         this.service.listTask('search', fromDate + ' 00:00:00', toDate + ' 23:59:59',
            0, 0, q, 8, '', '', '')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResult = data;
                  }
               });
      }, 300);
   }

   onClickAdvance() {
      const dialogRef = this.dialog.open(AdvanceSearchDialogComponent, {
         disableClose: true,
         minWidth: '580px',
         data: this,
      });

      dialogRef.afterClosed().subscribe(result => {
         if (result.result) {
            this.item = {
               taskName: result.itemSearch.taskName,
               statusSearch: result.itemSearch.statusSearch,
               emailSender: result.itemSearch.emailSender,
               emailSigner: result.itemSearch.emailSigner,
               sentDateFrom: result.itemSearch.sentDateFrom,
               sentDateTo: result.itemSearch.sentDateTo,
               lastUpdateFrom: result.itemSearch.lastUpdateFrom,
               lastUpdateTo: result.itemSearch.lastUpdateTo
            };
            const url = Path.combine('/tasks/searchAdvanced', encodeURIComponent(JSON.stringify(this.item)));
            sessionStorage.setItem('taskPath', url);
            sessionStorage.setItem('itemSearch', JSON.stringify(this.item));

            if (this.status === 'searchAdvance') {
               this.getTaskList('searchAdvance');
            } else {
               this.router.navigate([url]);
            }
         }
      });
   }

   onStartTutorial(): void {
      this.translate.get('tutorial').subscribe((msg) => {
         const enjoyhint_instance = new EnjoyHint({});
         const enjoyhint_script_steps: any = [
            {
               'next #sign-hint-item': msg.tasks.navTask,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close}
            },
            {
               'next #settings-hint': msg.tasks.navSetting,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close}
            }
         ];
         if (this.canNewTask()) {
            enjoyhint_script_steps.push({
               'next #new-task-hint': msg.tasks.newTask,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
            });
         }
         const lengthStep = enjoyhint_script_steps.length - 1;
         enjoyhint_script_steps[lengthStep].nextButton = {'text': msg.close};
         enjoyhint_script_steps[lengthStep].showSkip = false;
         enjoyhint_instance.set(enjoyhint_script_steps);
         enjoyhint_instance.run();
      });
   }

   // for task list

   select(div: any, selector: any) {
      selector.style.left = (div.offsetLeft + div.clientWidth / 2 - 12) + 'px';
   }

   navigateTask(item: any) {
      if (item.taskStatus === 'Draft') {
         this.openNewTaskDraft(item);
      } else {
         this.router.navigate(['/signdoc', item.taskId], {replaceUrl: true});
      }
   }

   // check show menu reassign only status Need to sign and Wait for sign
   isReassign(task) {
      const status = task.taskStatus.toLowerCase();
      if (this.status === 'deleted') {
         return false;
      } else if ((status === 'need to sign' || status === 'waiting for sign') && task.sender.toLowerCase() !== this.service.user.email.toLowerCase()) {
         return true;
      }
      return false;
   }

   isSenderReassign(task) {
      const status = task.taskStatus.toLowerCase();
      if (this.status === 'deleted' || task.isDelete) {
         return false;
      } else if (task.sender.toLowerCase() === this.service.user.email.toLowerCase() && (status !== 'completed' && status !== 'draft' && status !== 'reject')) {
         return true;
      }
      return false;
   }

   isDeleted(statusDocument, sender, isDelete) {
      const statusLower = statusDocument.toLowerCase();
      if (this.status === 'deleted' || isDelete) {
         return true;
      } else if (sender.toLowerCase() === this.service.user.email.toLowerCase()) {
         if (statusLower !== 'completed') {
            return true;
         }
      }
      return false;
   }

   isRestore(statusDocument, sender, isDelete) {
      if (this.status !== 'deleted' && !isDelete) {
         return false;
      }
      return true;
   }

   isResend(item) {
      const statusLower = item.taskStatus.toLowerCase();
      if (this.status === 'deleted') {
         return false;
      } else if (statusLower === 'reject' && item.sender.toLowerCase() === this.service.user.email.toLowerCase()) {
         return true;
      }
      return false;
   }

   // check show menu remind only sender and status in progress but not status need to sign and review
   isRemind(item) {
      const statusLower = item.taskStatus.toLowerCase();
      if (statusLower !== 'completed' && statusLower !== 'reject'
         && statusLower !== 'draft' && statusLower !== 'need to sign'
         && statusLower !== 'review' && this.status !== 'deleted'
         && item.sender.toLowerCase() === this.service.user.email.toLowerCase()) {
         return true;
      }
      return false;
   }

   getIcon (item: any): string {
      switch (item.taskStatus) {
         case 'Need to sign':
            return 'assets/icons/task_sign_color.svg';
         case 'Waiting for sign':
            return 'assets/icons/task_pending_color.svg';
         case 'Waiting for others':
            return 'assets/icons/task_sign_wait_color.svg';
         case 'Waiting':
            return 'assets/icons/task_pending_color.svg';
         case 'Reject':
            return 'assets/icons/task_reject_color.svg';
         case 'Draft':
            return 'assets/icons/task_draft_color.svg';
         case 'Deleted':
            return 'assets/icons/task_delete_color.svg';
         default:
            return 'assets/icons/task_completed_color.svg';
      }
   }

   openRejReason(item: any) {
      this.viewRejReason = this.dialog.open(RejectReasonComponent, {
         disableClose: true,
         data: this,
         height: '280px',
         width: '450px'
      });
      this.viewRejReason.componentInstance.rejReason = item.rejectRaason;
      this.viewRejReason.afterClosed()
         .subscribe((result) => {
            this.activeItem = undefined;
            if (item) {
               item.selected = false;
            }
         });
   }

   openFlow(item: any) {
      this.viewFlow = this.dialog.open(ViewFlowComponent, {
         disableClose: true,
         data: this,
         minHeight: '550px',
         maxHeight: '1000px',
         width: '630px'
      });
      this.viewFlow.componentInstance.id = item.taskId;
      this.viewFlow.componentInstance.taskStatus = item.taskStatus;
      this.viewFlow.afterClosed()
         .subscribe((result) => {
            this.activeItem = undefined;
            if (item) {
               item.selected = false;
            }
         });
   }

   onExportFile(item:any){
      if(!localStorage.getItem('access_token')){
         this.socialLogin.withMicrosoft().subscribe(result => {
            if(localStorage.getItem('access_token')){
               this.openDialogExportFile(item);
            }
         }, error => {
            this.toast.error(error);
         });
      }else{
         this.openDialogExportFile(item);
      }
   }

   onExportZdox(item:any){
      this.exportDialog = this.dialog.open(ExportTaskDialogComponent, {
         disableClose: true,
         data: {service: this.service, data: this, toast: this.toast, translate: this.translate,zDoxExport: true}
      });
      this.exportDialog.afterClosed().subscribe((result) => {
         if(result){
            let path = result.pathSelect.split("/");
            let pathTarget = path[path.length-1];
            if(pathTarget === ""){
               pathTarget = "Files";
            }
            this.service.zDoxExportDocument(item.taskId,result.pathId).subscribe( res => {
                  this.loader.hide();
                  this.translate.get('export-task-zdox', {path: pathTarget}).subscribe(msg => {
                     this.toast.success(msg)
                  });
               },
               (err) => {
                  this.toast.error(err.message);
               })
         }
      });
   }

   openDialogExportFile(item:any){
      this.exportDialog = this.dialog.open(ExportTaskDialogComponent, {
         disableClose: true,
         data: {service: this.service, data: this, toast: this.toast, translate: this.translate ,onedriveExport:true}
      });

      var path = ""
      this.exportDialog.componentInstance.pathSite = path;
      this.exportDialog.afterClosed().subscribe((result) => {
         if(result){
            this.loader.show();
            this.service.onedriveExportDocument(item.taskId,result.token,result.pathId).subscribe( res => {
               this.loader.hide();
               this.translate.get('export-task-success', {target: "OneDrive"}).subscribe(msg => {
                  this.toast.success(msg)
               });

            },
            error => {
               this.loader.hide();
               if(error.status === 401 && error.error){
                  this.toast.error('Access token has expired or is not yet valid.');
               }else{
                  this.toast.error(error.message);
               }
            })
         }
      });
   }

   onExportFileGoogleDrive(item:any){
      if(!sessionStorage.getItem('access_token_google')){
         this.socialLogin.withGoogle().subscribe(result => {
            this.openDialogExportGoogleDrive(item);
         }, error => {
            this.toast.error(error);
         });
      }else{
         this.openDialogExportGoogleDrive(item);
      }
   }

   openDialogExportGoogleDrive(item:any){
      this.exportDialog = this.dialog.open(ExportTaskDialogComponent, {
         disableClose: true,
         data: {service: this.service, data: this, toast: this.toast, translate: this.translate ,googleExport:true}
      });

      var path = ""
      this.exportDialog.componentInstance.pathSite = path;
      this.exportDialog.afterClosed().subscribe((result) => {
         if(result){
            this.loader.show();
            this.service.googleDriveExportDocument(item.taskId,result.token,result.pathId).subscribe( res => {
                  this.loader.hide();
                  this.translate.get('export-task-success', {target: "Google Drive"}).subscribe(msg => {
                     this.toast.success(msg)
                  });

               },
               error => {
                  this.loader.hide();
                  if(error.status === 401){
                     this.toast.error('Access token has expired or is not yet valid.');
                  }else{
                     this.toast.error(error.message);
                  }
               })
         }
      });
   }

   onExportFileDropBox(item:any){
      if(!localStorage.getItem('access_token_dropbox')){
         this.socialLogin.withDropBox().subscribe(result => {
            this.openDialogExportDropBox(item);
         }, error => {
            this.toast.error(error);
         });
      }else{
         this.openDialogExportDropBox(item);
      }
   }

   openDialogExportDropBox(item:any){
      this.exportDialog = this.dialog.open(ExportTaskDialogComponent, {
         disableClose: true,
         data: {service: this.service, data: this, toast: this.toast, translate: this.translate ,dropboxExport:true}
      });

      var path = ""
      this.exportDialog.componentInstance.pathSite = path;
      this.exportDialog.afterClosed().subscribe((result) => {
         if(result){
            this.loader.show();
            var path = "";
            if(this.exportDialog.componentInstance.pathSelect) {
               path = this.exportDialog.componentInstance.pathSelect;
            }
            this.service.dropBoxExportDocument(item.taskId,result.token,path).subscribe( res => {
                  this.loader.hide();
                  this.translate.get('export-task-success', {target: "Dropbox"}).subscribe(msg => {
                     this.toast.success(msg)
                  });

               },
               error => {
                  this.loader.hide();
                  if(error.status === 401){
                     this.toast.error('Access token has expired or is not yet valid.');
                  }else{
                     this.toast.error(error.message);
                  }
               })
         }
      });
   }

   isCanExport(item:any){
      return ( this.service.user.email.toLowerCase() === item.sender && item.taskStatus.toLowerCase() === 'completed' );
   }

   openNewTaskDraft(item: any) {
      this.router.navigate(['/create-task'],
         {
            queryParams: {
               data: JSON.stringify({
                  taskId: item.taskId,
                  item: {
                     id: item.id
                  },
                  mode: 'edit',
                  isResend: true
               })
            }
         });
   }

   openReassign(data: any) { // TODO: after reassign refresh table
      const dialogRef = this.dialog.open(ReassignDialogComponent, {
         disableClose: true,
         height: '220px',
         width: '680px',
         data: {service: this.service, toast: this.toast, item: data}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.googleAnalyticsService.trackEvent('zdox-task',{
               event_page: "task",
               event_label: "resassign",
               event_action: "resassign"
           });

            this.getTaskList('load');
         }
      });
   }

   openSenderReassign(data: any) { // TODO: after reassign refresh table
      const dialogRef = this.dialog.open(SenderReassignDialogComponent, {
         disableClose: true,
         height: '250px',
         width: '680px',
         data: {service: this.service, toast: this.toast, item: data}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.googleAnalyticsService.trackEvent('zdox-task',{
               event_page: "task",
               event_label: "resassign",
               event_action: "resassign"
           });

            this.getTaskList('load');
         }
      });
   }

   deleteTask(item: any) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      dialogRef.componentInstance.messageWarning = item.taskName;
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            if (this.status === 'deleted' || item.isDelete) {
               this.service.deleteTaskInTrash(item)
                  .subscribe((response) => {
                     this.toast.success(response);
                     this.getTaskList('load');
                  });
            } else {
               this.service.deleteTask(item)
                  .subscribe((response) => {
                     this.toast.success(response);
                     this.getTaskList('load');
                  });
            }
         }
      });
   }

   restoreTask(item: any) {
      this.service.restoreTask(item)
         .subscribe(
            (response) => {
               this.toast.success(response);
               this.getTaskList('load');
            });
   }

   rejectResendDocument(item) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('signOff.resend').subscribe(s => {
         dialogRef.componentInstance.messageBtnOK = s;
      });
      this.translate.get('signDoc.confirmResend').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isResend = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         dialogRef.componentInstance.isResend = false;
         if (result) {
            this.service.resendTask(item.taskId).subscribe((response) => {
               this.openNewTaskDraft(item);
            });
         }
      });
   }

   remindTask(item) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('ok').subscribe(s => {
         dialogRef.componentInstance.messageBtnOK = s;
      });
      this.translate.get('signDoc.confirmRemind').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isResend = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         dialogRef.componentInstance.isResend = false;
         if (result) {
            this.service.remindTask(item.taskId).subscribe((response) => {
               this.googleAnalyticsService.trackEvent('zdox-task',{
                  event_page: "task",
                  event_label: "remind",
                  event_action: "remind"
              });
               this.toast.success(response);
            });
         }
      });
   }

   highlight(row) {
      if (!this.clickActive) {
         this.selectedRowIndex = row.taskId;

         this.info = undefined;
         this.previewLoaded = false;
         this.activeItem = row;

         this.setSortPaging();
         this.navigateTask(row);

      }
      this.clickActive = false;
   }

   openLogHistoryTask(items: any) {
      this.service.getHistoryActivityTask(items.taskId).subscribe((response) => {
         const dialogRef = this.dialog.open(HistoryActivityDialogComponent, {
            disableClose: true,
            minHeight: '200px',
            width: '800px',
            data: {
               service: this.service, item: response, data: this, toast: this.toast, translate: this.translate
            }
         });
         dialogRef.afterClosed().subscribe(result => {
            // This is intentional.
         });
      });
   }

   changeLanguageChannelAccess(item: any) {
      switch (item.channelAccess) {
         case 'Web':
            item.channelAccess = 'เว็บ';
            break;
         case 'Mobile':
            item.channelAccess = 'มือถือ';
            break;
      }
   }

   changeLanguageTaskAction(item: any) {
      const taskAction = item.taskAction.toLowerCase();
      switch (taskAction) {
         case 'sign':
            item.taskAction = 'อนุมัติงาน';
            break;
         case 'delete task':
            item.taskAction = 'ลบงาน';
            break;
         case 'restore':
            item.taskAction = 'กู้คืนงาน';
            break;
         case 'resend':
            item.taskAction = 'ส่งงานใหม่';
            break;
         case 'draft':
            item.taskAction = 'งานร่าง';
            break;
         case 'save task':
            item.taskAction = 'บันทึกงาน';
            break;
         case 'send':
            item.taskAction = 'ส่งงาน';
            break;
         case 'reject':
            item.taskAction = 'ไม่อนุมัติ';
            break;
         case 'reassign':
            item.taskAction = 'มอบหมายงาน';
            break;
         case 'download':
            item.taskAction = 'ดาวน์โหลด';
            break;
         case 'download all':
            item.taskAction = 'ดาวน์โหลดเอกสารทั้งหมด';
            break;
         case 'combine download':
            item.taskAction = 'ดาวน์โหลดรวมเอกสาร';
            break;
         case 'close task':
         case 'close':
            item.taskAction = 'ปิดงาน';
            break;
         case 'view task':
            item.taskAction = 'ดูงาน';
            break;
         case 'edit task':
            item.taskAction = 'แก้ไขงาน';
            break;
         case 'set document type':
            item.taskAction = 'ตั้งค่าประเภทเอกสาร';
            break;
         case 'edit metadata':
            item.taskAction = 'แก้ไขข้อมูลเพิ่มเติม';
            break;
         case 'add attach file':
            item.taskAction = 'เพิ่มไฟล์แนบ';
            break;
         case 'delete attach file':
            item.taskAction = 'ลบไฟล์แนบ';
            break;
         case 'view log reassign':
            item.taskAction = 'ดูประวัติการมอบหมายงาน';
            break;
      }
   }

   groupHeaderClick(row) {

      this.taskDataSource = new MatTableDataSource<TaskList | Group>([]);
      if (row.expanded) {
         row.expanded = false;
      } else {
         row.expanded = true;
         this.expandedSender = row;
      }
      const dataTasks = this.addGroupsNew(this._allGroup, this.allData, this.groupByColumns, row);
      this.taskDataSource = new MatTableDataSource(dataTasks);
   }

   getGroups(data: any[], groupByColumns: string[]): any[] {
      const rootGroup = new Group();
      rootGroup.expanded = false;
      return this.getGroupList(data, 0, groupByColumns, rootGroup);
   }

   getGroupList(data: any[], level: number = 0, groupByColumns: string[], parent: Group): any[] {
      if (level >= groupByColumns.length) {
         return data;
      }
      const groups = this.uniqueBy(
            data.map(
               row => {
                  const result = new Group();
                  result.level = level + 1;
                  for (let i = 0; i <= level; i++) {
                     result.groupSender = row[groupByColumns[i]];
                  }
                  return result;
               }
            ),
            JSON.stringify);
      if(this.groupType === 'sd') {
         groups.forEach(group => {
            const rowsInGroup = data.filter(row => group.groupSender === row.sender);
            group.totalCounts = rowsInGroup.length;
         });
      }else if(this.groupType === 'st') {
         groups.forEach(group => {
            const rowsInGroup = data.filter(row => group.groupSender === row.taskStatus);
            group.totalCounts = rowsInGroup.length;
         });
      }
      this._allGroup = groups;
      return groups;
   }

   addGroupsNew(allGroup: any[], data: any[], groupByColumns: string[], dataRow: any): any[] {
      return this.getSublevelNew(allGroup, data, 0, groupByColumns);
   }

   getSublevelNew(allGroup: any[], data: any[], level: number, groupByColumns: string[]): any[] {
      if (level >= groupByColumns.length) {
         return data;
      }
      allGroup.sort((Group1,Group2) => { // sort count groups
         if (Group1.totalCounts < Group2.totalCounts) {
            return 1;
         } else if (Group1.totalCounts > Group2.totalCounts) {
            return -1;
         }

         return 0;
      });
      let subGroups = [];
      if(this.groupType === 'sd') {
         allGroup.forEach(group => {
            const rowsInGroup = data.filter(row => group.groupSender === row.sender);
            group.totalCounts = rowsInGroup.length;

            if (group.expanded) {
               this.expandedSubSender = rowsInGroup;
               subGroups = subGroups.concat(group);
               subGroups = subGroups.concat(rowsInGroup);
            } else {
               subGroups = subGroups.concat(group);
            }
         });
      }else if(this.groupType === 'st') {
         allGroup.forEach(group => {
            const rowsInGroup = data.filter(row => group.groupSender === row.taskStatus);
            group.totalCounts = rowsInGroup.length;
            const groupName = this.translateGroupping(group.groupSender);
            this.translate.get(groupName).subscribe(s => {
               group.groupName = s;
            });

            if (group.expanded) {
               this.expandedSubSender = rowsInGroup;
               subGroups = subGroups.concat(group);
               subGroups = subGroups.concat(rowsInGroup);
            } else {
               subGroups = subGroups.concat(group);
            }
         });
      }
      return subGroups;
   }

   translateGroupping(group){ //translate typeGroupping
      let groupName;
      switch (group) {
         case 'Need to sign':
            groupName = 'main.need2sign';
            break;
         case 'Waiting for others':
            groupName = 'main.taskWaitOther';
            break;
         case 'Waiting for sign':
            groupName = 'main.taskWaitSign';
            break;
         case 'Completed':
            groupName = 'main.tasksCompleted';
            break;
         case 'Draft':
            groupName = 'main.tasksDraft';
            break;
         case 'Reject':
            groupName = 'main.tasksReject';
            break;
         case 'Review':
            groupName = 'main.tasksReview';
            break;
         case 'Waiting':
            groupName = 'main.tasksWait';
            break;
      }
      return groupName;
   }

   uniqueBy(a, key) {
      const seen = {};
      return a.filter((item) => {
         const k = key(item);
         return seen.hasOwnProperty(k) ? false : (seen[k] = true);
      });
   }

   isGroup(index, item): boolean {
      return item.hasOwnProperty('groupSender');
   }

   private compare(a, b, isAsc) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
   }

      //** get Attach image by ID */
   getAttachImage(taskId: number){
      this.service.getAttachImage(taskId)
      .subscribe((response) => {
      this.submitDeleteFile(response);
      });
   }

   //** ลบไฟล์แนบเอกสาร */
   submitDeleteFile(array_file: string []) {
      if(array_file !== undefined || array_file.length >0){
         for (let i = 0; i < array_file.length; i++) {
            this.service.deleteDocument(array_file[i])
            .subscribe((response) => {
            },
            (err) => {
               console.error(err);
            });
         }
      }
   }

   groupChange(value: string){
      if(value){
         this.groupType = value;
         localStorage.removeItem('group_type');
         localStorage.setItem('group_type', value);
         if(this.groupType === 'sd'){
            this.groupByColumns = ['sender'];
         }else if(this.groupType === 'st'){
            this.groupByColumns = ['taskStatus'];
         }
         this.selection.clear();
         this.getTaskList('load');
      }
   }

   initializeYearOptions() {
      const currentYear = new Date().getFullYear();
      this.yearOptions = [];
      for (let i = 0; i < 4; i++) {
         const year = currentYear - i;
         this.yearOptions.push({
            display: year,
            value: year.toString()
         });
      }
      this.refreshFilterOptions();
   }

   filterChange(value: string) {
      this.filterType = value;
      this.dataService.taskFilterType = this.filterType;
      this.page = 0;
      this.getTaskList('filter');
   }

   /* Trigger text is rendered by the parent view so it survives async translation loading (mat-select is OnPush). */
   filterTypeDisplay() {
      const year = this.yearOptions.find(option => option.value === this.filterType);
      return year ? year.display : '';
   }

   groupTypeLabel(): string {
      switch (this.groupType) {
         case 'st': return 'grouping.status';
         case 'sd': return 'grouping.sender';
         case 'ng': return 'grouping.no-grouping';
         default : return '';
      }
   }

   /* Populates dateRangeOptions/groupByOptions in place — called once yearOptions is known
      (initializeYearOptions) and again once translations are confirmed loaded (the 'main'
      subscribe in ngOnInit), rather than from the template, so [options] keeps a stable array
      reference between change-detection passes. */
   private refreshFilterOptions(): void {
      this.dateRangeOptions = [
         {value: '6m', label: this.translate.instant('filter.last-6-months')},
         ...this.yearOptions.map(year => ({value: year.value, label: String(year.display)}))
      ];
      this.groupByOptions = [
         {value: 'ng', label: this.translate.instant('grouping.no-grouping')},
         {value: 'st', label: this.translate.instant('grouping.status')},
         {value: 'sd', label: this.translate.instant('grouping.sender')}
      ];
   }

   private pad2(n: number): string {
      return n.toString().padStart(2, '0');
   }

   private getFilterDateRange(): {fromDate: string, toDate: string} {
      const d = new Date();
      // Only a 4-digit value is a year option; note parseInt('6m', 10) would yield 6, not NaN
      const isYearOption = /^\d{4}$/.test(this.filterType);
      const selectedYear = parseInt(this.filterType, 10);
      let fromDateObj: Date;
      let toDateObj = d;

      if (!isYearOption) {
         // '6m' (and any unexpected value) falls back to the rolling 6-month window
         fromDateObj = new Date(d.getFullYear(), d.getMonth() - 6, 1);
      } else {
         // A year option covers that year only; the current year stops at today
         fromDateObj = new Date(selectedYear, 0, 1);
         if (selectedYear < d.getFullYear()) {
            toDateObj = new Date(selectedYear, 11, 31);
         }
      }

      const fromDate = `${fromDateObj.getFullYear()}-${this.pad2(fromDateObj.getMonth() + 1)}-01`;
      const toDate = `${toDateObj.getFullYear()}-${this.pad2(toDateObj.getMonth() + 1)}-${this.pad2(toDateObj.getDate())}`;
      return {fromDate, toDate};
   }

   onCheckboxChange(checked: boolean, row: any): void {
      if (checked) {
         this.selection.select(row);
      } else {
         this.selection.deselect(row);
      }
   }

   onCheckboxClick(event: MouseEvent, row: any): void {
      if (!this.selection.isSelected(row) && this.selection.selected.length >= this.maxSelectItems) {
         event.preventDefault();
         event.stopPropagation();

         this.translate.get('taskList.maxSelectItems', {limit: this.maxSelectItems}).subscribe(s => {
            this.toast.error(s);
         });
      }
   }

   selectedDownload() {
      const listTasks = [];

      if (this.selection) {
         for (const itemSel of this.selection.selected) {
            listTasks.push(itemSel.taskId);
         }

         this.includeAuditTrialDialog = this.dialog.open(IncludeAuditTrailComponent, {
            disableClose: true,
            data: {}
         });

         this.includeAuditTrialDialog.afterClosed().subscribe(result => {
            if(result){
               this.dialog.open(DownloadMultipleTaskComponent, {
                  disableClose: true,
                  data: {
                     includeAuditTrail: this.includeAuditTrialDialog.componentInstance.includeAuditTrail,
                     listTasks: listTasks,
                     service: this.service
                  }
               });
            }
         });
      }
   }
}

export interface TaskList {
   taskId: number;
   taskName: string;
   dueDate: string;
   priority: number;
   taskStatus: string;
   sender: string;
   currentLevel: number;
   lastUpdateDate: string;
   rejectRaason: string;
   createDate: string;
   lastUpdateBy: string;
}

export class Group {
   level = 0;
   groupSender: string;
   expanded = true;
   groupName: String;
   totalCounts = 0;
}
